export default "__VITE_ASSET__5798e4f7__"